import React,{useState, useEffect} from "react";
import { Link, useNavigate } from "react-router-dom";



// const navigate = useNavigate();

const WatchLater = () => {

  const navigate = useNavigate();
  const [watchLater, setWatchLater] = useState(null);

  useEffect(()=>{
      let data = JSON.parse(localStorage.getItem("userDetails"));

      setWatchLater(data.watchLater.length===0 ? null : data.watchLater);
      // console.log(data.watchLater);

      // localStorage.setItem("userDetails", JSON.stringify(data));
  },[])

  function ShortNumber(number) {

      if (number >= 1000000) {
        return (number / 1000000).toFixed(1) + "M";
      } else if (number >= 1000) {
        return (number / 1000).toFixed(1) + "k";
      } else {
        return number.toString();
      }
    }


    const playRandom =()=>{
      let data = JSON.parse(localStorage.getItem("userDetails"));
      let chosenVideo = data.favorite[Math.floor(Math.random()*(data.favorite.length+1))];
  
      let vidId = chosenVideo.video_id;
      navigate(`/play/:${vidId}`);
  
     
  
    }


  return (
    <div className="flex flex-col sm:flex-row sm:h-[90vh] bg-black sm:p-8">
      {  !watchLater && <div className="text-center text-white font-bold h-screen w-screen z-30 bg-red-500 flex flex-col justify-center items-center">
        <h1 className="text-4xl font-extrabold">No videos</h1>
        <p className="text-lg mt-4">Please add some videos to Watch Later.</p>

        <Link to={'/'} className="bg-red-300 px-4 py-2 rounded-lg hover:bg-red-700">
          {"<-Back"}
        </Link>
      </div>}

      {watchLater &&   
        (<div className=" rounded-lg bg-gradient-to-t from-black to-red-600 text-white sm:p-4 w-full sm:w-1/4">
        <div className="main sm:m-3 bg-transparent text-center sm:text-start ">

          <div  className=" bg-purple-500 overflow-hidden rounded-lg m-5 lg:aspect-none group-hover:opacity-75 ">
            <img
               src={watchLater[0]?.thumbnails[0].url} alt={watchLater[0]?.title}


                className="max-h-48  w-full object-cover object-center lg:h-full lg:w-full"
            />


       </div>
          {/* <div className="w-full">
            <img
              src="https://i.ytimg.com/vi/hNhxsNNqWw4/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLChTDxqW7FJCofO_nLEVvEOnyTsOg"
              alt="Watch Later"
              className="rounded-lg mb-4"
            />
          </div> */}

          <h2 className="ml-5 text-xl sm:text-green-500 font-bold mb-2">Watch later</h2>
          <p className="ml-5 mb-4">{watchLater[0]?.author}</p>
          <p className="ml-5 mb-4">{`${watchLater.length} videos ${watchLater[0]?.number_of_views} views Updated on ${watchLater[watchLater.length-1]?.published_time}`}</p>
          <div className="ml-5 flex justify-evenly mb-4">
            <Link to={'/'} className="bg-red-500 px-4 py-2 rounded-lg hover:bg-red-700">
              {"<-Back"}
            </Link>
            <button onClick={()=>playRandom()} className="bg-gray-700 px-4 py-2 rounded-lg">
              Shuffle and play
            </button>
          </div>
        </div>
      </div>)}

     { watchLater && 
       <div className="flex-1 overflow-y-auto  p-4">
        <div className="text-white">
        {console.log(watchLater)}
          {
            watchLater.map((video, index) => (
            <Link to ={`/play/:${video.video_id}`} key={index} className="flex mb-4">
              
              <div className=" sm:w-[10rem] sm:h-[5rem] w-[9rem]w h-[5.7rem] bg-pink-500 overflow-hidden rounded-lg  lg:aspect-none group-hover:opacity-75 ">
                  <img
                         src={video.thumbnails[0].url} alt={video.title}
                        className=" object-cover object-center w-full h-full   "
                  />

                 <div className='badge bg-red-500 text-end'>
                    <p className = "   text-sm font-bold  inline bg-black text-white z-20 px-1 relative bottom-7 mx-2  rounded-md">  {video.vedio_length}</p>
                 </div>
              </div>
              {/* <img
                src={video.thumbnail}
                alt={video.title}
                className="w-1/4 rounded-lg"
              /> */}
              <div className="ml-4 flex-1 text-gray-500">
                <h3 className="hidden sm:block text-xl text-gray-200 font-bold">
                  {(video.title).length > 75 ? video.title.slice(0,74) + '...' : video.title}
                </h3>

                <h3 className="block sm:hidden font-semibold text-gray-200">
                  {(video.title).length > 49 ? video.title.slice(0,48) + '...' : video.title}
                </h3>
                <p>{video.author}</p>
                <p>{ShortNumber(video.number_of_views)
                } • {video.published_time
                }</p>
              </div>
            
            </Link>
          ))}
        </div>
      </div>
     }
    </div>
  );
};

export default WatchLater;



// import React,{ useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';

// const videos = [
//   {
//     title: "Topper's Strategy | Follow this \"To do list\" in June for Bank Exams 2024 | by Vishal Parihar sir",
//     channel: "Bankers Way by Unacademy",
//     views: "7.2K views",
//     time: "10 hours ago",
//     thumbnail: "https://i.ytimg.com/vi/hNhxsNNqWw4/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLChTDxqW7FJCofO_nLEVvEOnyTsOg",
//     length: "11:41",
//   },
//   {
//     title: "How To Cover Both Prelims and Mains Combined for IBPS PO 2024 | 100% Result Oriented Strategy |",
//     channel: "RIGHT APPROACH",
//     views: "2.2K views",
//     time: "4 days ago",
//     thumbnail: "https://i.ytimg.com/vi/hNhxsNNqWw4/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLChTDxqW7FJCofO_nLEVvEOnyTsOg",
//     length: "35:24",
//   },
//   {
//     title: "Complete Data Interpretation in 12 Hrs - All Type DI Sets | IBPS | SBI | RBI | Bank Exam",
//     channel: "Maths By Arun Sir",
//     views: "187K views",
//     time: "11 months ago",
//     thumbnail: "https://i.ytimg.com/vi/hNhxsNNqWw4/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLChTDxqW7FJCofO_nLEVvEOnyTsOg",
//     length: "1:40:29",
//   },
//   {
//     title: "Complete Data Interpretation in 12 Hrs - All Type DI Sets | IBPS | SBI | RBI | Bank Exam",
//     channel: "Maths By Arun Sir",
//     views: "187K views",
//     time: "11 months ago",
//     thumbnail: "https://i.ytimg.com/vi/hNhxsNNqWw4/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLChTDxqW7FJCofO_nLEVvEOnyTsOg",
//     length: "1:40:29",
//   },
//   {
//     title: "Complete Data Interpretation in 12 Hrs - All Type DI Sets | IBPS | SBI | RBI | Bank Exam",
//     channel: "Maths By Arun Sir",
//     views: "187K views",
//     time: "11 months ago",
//     thumbnail: "https://i.ytimg.com/vi/hNhxsNNqWw4/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLChTDxqW7FJCofO_nLEVvEOnyTsOg",
//     length: "1:40:29",
//   },
//   {
//     title: "Complete Data Interpretation in 12 Hrs - All Type DI Sets | IBPS | SBI | RBI | Bank Exam",
//     channel: "Maths By Arun Sir",
//     views: "187K views",
//     time: "11 months ago",
//     thumbnail: "https://i.ytimg.com/vi/hNhxsNNqWw4/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLChTDxqW7FJCofO_nLEVvEOnyTsOg",
//     length: "1:40:29",
//   },
//   {
//     title: "Complete Data Interpretation in 12 Hrs - All Type DI Sets | IBPS | SBI | RBI | Bank Exam",
//     channel: "Maths By Arun Sir",
//     views: "187K views",
//     time: "11 months ago",
//     thumbnail: "https://i.ytimg.com/vi/hNhxsNNqWw4/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLChTDxqW7FJCofO_nLEVvEOnyTsOg",
//     length: "1:40:29",
//   },
//   {
//     title: "Complete Data Interpretation in 12 Hrs - All Type DI Sets | IBPS | SBI | RBI | Bank Exam",
//     channel: "Maths By Arun Sir",
//     views: "187K views",
//     time: "11 months ago",
//     thumbnail: "https://i.ytimg.com/vi/hNhxsNNqWw4/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLChTDxqW7FJCofO_nLEVvEOnyTsOg",
//     length: "1:40:29",
//   },
//   {
//     title: "Complete Data Interpretation in 12 Hrs - All Type DI Sets | IBPS | SBI | RBI | Bank Exam",
//     channel: "Maths By Arun Sir",
//     views: "187K views",
//     time: "11 months ago",
//     thumbnail: "https://i.ytimg.com/vi/hNhxsNNqWw4/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLChTDxqW7FJCofO_nLEVvEOnyTsOg",
//     length: "1:40:29",
//   },
//   {
//     title: "Complete Data Interpretation in 12 Hrs - All Type DI Sets | IBPS | SBI | RBI | Bank Exam",
//     channel: "Maths By Arun Sir",
//     views: "187K views",
//     time: "11 months ago",
//     thumbnail: "https://i.ytimg.com/vi/hNhxsNNqWw4/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLChTDxqW7FJCofO_nLEVvEOnyTsOg",
//     length: "1:40:29",
//   },
//   {
//     title: "Complete Data Interpretation in 12 Hrs - All Type DI Sets | IBPS | SBI | RBI | Bank Exam",
//     channel: "Maths By Arun Sir",
//     views: "187K views",
//     time: "11 months ago",
//     thumbnail: "https://i.ytimg.com/vi/hNhxsNNqWw4/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLChTDxqW7FJCofO_nLEVvEOnyTsOg",
//     length: "1:40:29",
//   },
//   // Add more videos as needed
// ];

// const WatchLater = () => {

//     const [watchLater, setWatchLater] = useState(null);

//     useEffect(()=>{
//         let data = JSON.parse(localStorage.getItem("userDetails"));

//         setWatchLater(data.watchLater);
//         console.log(data.watchLater);

//         // localStorage.setItem("userDetails", JSON.stringify(data));
//     },[])

//     function ShortNumber(number) {

//         if (number >= 1000000) {
//           return (number / 1000000).toFixed(1) + "M";
//         } else if (number >= 1000) {
//           return (number / 1000).toFixed(1) + "k";
//         } else {
//           return number.toString();
//         }
//       }
    

//   return (
//     <div className="flex  flex-col sm:flex-row  h-fit sm:p-5 bg-black">
      
//       {/* Static Left-up Section */}
//       {watchLater &&
//        <div className="rounded-md  bg-gradient-to-t from-black to-red-600 text-white sm:p-6  w-full h-fit sm:w-1/4">
//         <div className='flex flex-col '>
        
        

//         <div  className=" bg-purple-500 overflow-hidden rounded-lg m-5 lg:aspect-none group-hover:opacity-75 ">
//             <img
//                 src={watchLater[0]?.thumbnails[0].url} alt={watchLater[0]?.title}

                
//                 className="max-h-48  w-full object-cover object-center lg:h-full lg:w-full"
//             />
               
               
//             </div>

//               <div className='flex flex-col justify-center items-center'>

//                 <h2 className="text-xl font-bold mb-2">Watch later</h2>
//                 <p className="mb-4">{watchLater[0]?.author}</p>
//                 <p className="mb-4">{`${watchLater.length} videos ${watchLater[0]?.number_of_views} views Updated on ${watchLater[watchLater.length-1]?.published_time}`}</p>
//                 <div className="flex justify-evenly w-full space-x-2 mb-4">
//                 <button className="bg-red-700 px-4 py-2  rounded-lg">Play all</button>
//                 <button className="bg-gray-700 px-4 py-2 rounded-lg">Shuffle</button>
//                 </div>

//               </div>
//         </div>
//       </div>}

//       {/* Scrollable Right-down Section */}
//       <div className="flex sm:overflow-y-auto  p-4">
//         <div className="text-white">
          
//           {watchLater
//            && watchLater.map((video, index) => (
//             <Link to ={`/play/:${video.video_id}`} key={index} className="flex mb-4">
//               {/* <img src={video.thumbnail} alt={video.title} className="w-1/5 rounded-lg" /> */}
//               <div className=" w-[22.5rem] h-[5rem] bg-green-500 overflow-hidden rounded-lg  lg:aspect-none group-hover:opacity-75 ">
//                 <img
//                       src={video.thumbnails[0].url} alt={video.title}
//                       className=" object-cover object-center w-full h-full   "
//                 />
               
//                <div className='badge text-end'>
//                   <p className = "  text-sm font-bold  inline bg-black text-white z-20 px-1 relative bottom-7 mx-2  rounded-md">  {video.vedio_length}</p>
//                </div>
//             </div>
//               <div className=" ml-2 flex">
//                 <h3 className="sm:none bg-green-500 font-bold">{video.title}</h3>
//                 <h3 className="none sm:block text-lg font-bold">{video.title}</h3>
//                 <p>{video.author}</p>
//                 <p>{ShortNumber(video.number_of_views)
// } • {video.published_time
// }</p>
//               </div>
              
//             </Link>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WatchLater;
